<template>
    <div>


        <!--begin::Notice-->
        <b-alert
                show
                variant="light"
                class="alert alert-custom alert-white alert-shadow fade show gutter-b"
        >
            <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="media/svg/icons/Tools/Compass.svg" />
        </span>
            </div>
            <div class="alert-text">
                <b>Выберите</b> нужную страницу и отредактируйте
            </div>
        </b-alert>
        <!--end::Notice-->

        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Страницы</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>
                    <div class="card-body">

                        <div class="d-flex align-items-center mb-10">
                            <!--begin::Symbol-->
                            <div class="symbol symbol-40 symbol-light-primary mr-5">
                                    <span class="symbol-label">
                                        <span class="svg-icon svg-icon-lg svg-icon-primary">
                                            <!--begin::Svg Icon-->
                                            <inline-svg src="media/svg/icons/Files/File.svg"></inline-svg>
                                            <!--end::Svg Icon-->
                                        </span>
                                    </span>
                            </div>
                            <!--end::Symbol-->
                            <!--begin::Text-->
                            <div class="d-flex flex-column font-weight-bold">
                                <router-link :to="{ name: 'HomePage'}" class="text-dark text-hover-primary mb-1 font-size-lg">
                                    Главная страница
                                </router-link>
                                <span class="text-muted">
                                        Информация на главной странице
                                    </span>
                            </div>
                            <!--end::Text-->
                        </div>


                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>
                        <template v-else v-for="(page, i) in pages">
                            <!--begin::Item-->
                            <div class="d-flex align-items-center mb-10" v-bind:key="i">
                                <!--begin::Symbol-->
                                <div class="symbol symbol-40 symbol-light-primary mr-5">
                                    <span class="symbol-label">
                                        <span class="svg-icon svg-icon-lg svg-icon-primary">
                                            <!--begin::Svg Icon-->
                                            <inline-svg src="media/svg/icons/Files/File.svg"></inline-svg>
                                            <!--end::Svg Icon-->
                                        </span>
                                    </span>
                                </div>
                                <!--end::Symbol-->
                                <!--begin::Text-->
                                <div class="d-flex flex-column font-weight-bold">
                                    <router-link :to="{ name: 'PageEdit', params: {id: page.id}}" class="text-dark text-hover-primary mb-1 font-size-lg">
                                        {{ page.title }}
                                    </router-link>
                                    <span class="text-muted">
                                        {{ page.description }}
                                    </span>
                                </div>
                                <!--end::Text-->
                            </div>
                            <!--end::Item-->
                        </template>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {GET_PAGES} from "@/core/services/store/pages.module";
    export default {
        name: "Pages",
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Страницы сайта" }]);
            this.$store.dispatch(GET_PAGES)
        },
        computed: {
            ...mapGetters({
                pages: 'gettersPages',
                load: 'getPageLoad'
            }),

        },

        data() {
            return {
                style: "svg-icon-primary"
            }
        },
    }
</script>

<style scoped>

</style>